import { render, staticRenderFns } from "./RecoveryTask.vue?vue&type=template&id=70b4e011&scoped=true"
import script from "./RecoveryTask.vue?vue&type=script&lang=js"
export * from "./RecoveryTask.vue?vue&type=script&lang=js"
import style0 from "./RecoveryTask.vue?vue&type=style&index=0&id=70b4e011&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b4e011",
  null
  
)

export default component.exports